import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, of } from 'rxjs';
import * as Global from '../Model/CommanHttp';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginserviceService {

  constructor(private http: HttpClient, private router: Router) { }
  // private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // get isLoggedIn() {
  //   return this.loggedIn.asObservable();
  // }

  UserLogin(PLlogin: any): Observable<any> {

    const data = {
      Ind: 1,
      username: PLlogin["txtusername"],
      password: PLlogin["txtpassword"],
    }

    // var data = "username=" + PLlogin["txtusername"] + "&password=" + PLlogin["txtpassword"] + "&grant_type=password";
    // var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'No-Auth': 'True' });
    // return this.http.post(`${Global.base_url_Token}/token`, data, { headers: reqHeader });

    //this.loggedIn.next(true);
    return this.http.post(`${Global.base_url}/Login/GetLogin`, data, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('GetLogin')));

  }

  //  home page live auction bind and expired list bind
  GetAuctionGrid(Ind: any, OrgCode: any, CityCode: any): Observable<any> {

    const data = {
      Ind: Ind,
      OrgCode: OrgCode,
      CityCode: CityCode,

    }
    return this.http.get(`${Global.base_url}/Login/GetAuctionGrid?Ind=` + Ind + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('GetAuctionGrid')));
  }
  // ******* check user for generate password
  CheckUserName(Ind: number, UserNm: string): Observable<any> {
    return this.http.get(`${Global.base_url}/Login/ChkUserForGenPassword?Ind=` + Ind + '&UserNm=' + UserNm, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('ChkUserForGenPassword')));
  }
  //************ Password Generate */
  PasswordGenerate(data): Observable<any> {
    return this.http.post(`${Global.base_url}/Login/PwdGnrt`, data, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('PwdGnrt')));
  }

  DownloadDocument(AuctionId: any, OrgCode: any, CityCode: any): Observable<any> {

    return this.http.get(`${Global.base_url}/Login/DownloadDocument?Ind=` + 2 + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode + '&AuctionId=' + AuctionId).pipe(
      map(response => response), catchError(this.handleError<any>('DownloadDocument')));
  }
  /********************** Forgot Password ************************/
  CheckForgotPasswordUserName(Ind: number, UserNm: string,Ctg: number): Observable<any> {
    return this.http.get(`${Global.base_url}/Login/ChkUserForgotPassword?Ind=` + Ind + '&UserNm=' + UserNm + '&Ctg=' + Ctg, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('ChkUserForgotPassword')));
  }  
  CheckForgotOTP(mobno: string, Password: string): Observable<any> {
    return this.http.get(`${Global.base_url}/Login/CheckOTP?MobileNo=` + mobno + `&Password=` + Password, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('CheckOTP')));
  }
  ForgotPasswordUpdate(data): Observable<any> {
    return this.http.post(`${Global.base_url}/Login/ForgotPwdUpdate`, data, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('ForgotPwdUpdate')));
  }
  //For Error Handling
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
